import { Component, inject } from '@angular/core';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { FundSort } from '../../../../data-access/enums/fund-sort';

import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';

@Component({
  selector: 'app-sort-bottom-sheet',
  standalone: true,
  imports: [MatRadioModule],
  templateUrl: './sort-bottom-sheet.component.html',
  styleUrl: './sort-bottom-sheet.component.scss',
})
export class SortBottomSheetComponent {
  sortBy: FundSort;
  sorts: { title: string; value: FundSort }[] = [
    {
      title: 'پیش‌فرض',
      value: FundSort.Default,
    },
    {
      title: 'بیشترین سود',
      value: FundSort.MostProfit,
    },
    {
      title: 'کمترین قیمت سرمایه‌گذاری',
      value: FundSort.LeastPrice,
    },
    {
      title: 'کمترین ریسک',
      value: FundSort.LeastRisk,
    },
  ];

  private bottomSheet = inject(NgxBottomSheetService);

  constructor() {
    this.sortBy = this.bottomSheet.data().data;
  }

  onCloseModal(value?: FundSort) {
    // this.modalCloseHandler.emit(value || this.sortBy);
  }

  onSortChanged(val: MatRadioChange) {
    this.sortBy = val.value;
    this.bottomSheet.outputData.set(val.value);
    this.bottomSheet.closeBottomSheet();
  }
}
